import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { Vessel, VesselsService } from '../../vessels.service';
import { forkJoin } from 'rxjs';
import { PgMessagesService, MessageLevel } from 'src/app/shared/services/pg-messages.service';
import { ActionType, DataBaseActionService } from 'src/app/shared/services/database-action.service';
import { AuditReport, AuditsReportsService } from '../../audits-reports.service';
import { DocumentReference } from '../../../../documents/documents.service';
import { DateTimeZoneComponent, TimestampWithZone } from '../../../../shared/components/date-time-zone/date-time-zone.component';
import { DateTimeHelpers } from '../../../../shared/helpers/date-time.helpers';
import {KeycloakService} from '../../../../authentication/keycloak.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { AutoCompleteComponent } from 'src/app/shared/components/autocomplete/auto-complete.component';
import { OrganisationSelectorComponent } from 'src/app/shared/components/autocomplete/organisationselector.component';
import { ChunkFileUploadComponent } from 'src/app/shared/components/file-uploader/chunk-file-upload.component';
import { MaterialPdfViewerComponent } from 'src/app/shared/components/material-pdf-viewer/material-pdf-viewer.component';

@Component({
  selector: 'app-vessel-internal-audit',
  templateUrl: './vessel-internal-audit.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule, AutoCompleteComponent, OrganisationSelectorComponent, ChunkFileUploadComponent, DateTimeZoneComponent, MaterialPdfViewerComponent]
})
export class VesselInternalAuditComponent implements OnInit {
  vessels: Vessel[] = [];
  _selectedVessel!: Vessel;

  get selectedVessel() {
    return this._selectedVessel;
  }

  set selectedVessel(vessel: Vessel) {
    if (vessel) {
      this._selectedVessel = vessel;
      this.auditReport.vesselName = vessel.name!.name;
      this.auditReport.vesselImo = vessel.imo;
    }
  }

  locations: Organisation[] = [];
  _selectedLocation!: Organisation;
  get selectedLocation() {
    return this._selectedLocation;
  }

  set selectedLocation(value: Organisation) {
    if(value) {
      this._selectedLocation = value;
      this.auditReport.locationOrganisationId = value.name;
      this.auditDate = {
        timestamp: null!,
        timeZone: value.timezone
      };
    }
  }

  _auditDate!: TimestampWithZone;
  maxAuditReportDate = new Date();
  get auditDate() {
    return this._auditDate;
  }

  set auditDate(value: TimestampWithZone) {
    if(value) {
      this._auditDate = value;
      this.auditReport.isoDate = DateTimeHelpers.getISODateStringZoneId(new Date(value.timestamp!), value.timeZone!);
    }
  }

  uploadedDocument!: DocumentReference;
  auditReport: AuditReport = {
    vesselImo: '',
    vesselName: '',
    isoDate: '',
    locationOrganisationId: '',
    surveyorId: '',
    surveyorName: '',
    documentId: '',
    overallRating: 0,
    actions: [],
  };

  title = new EventEmitter<string>();

  constructor(private _organisationService: OrganisationService,
              private _vesselsService: VesselsService,
              private _pgMessagesService: PgMessagesService,
              private _actionService: DataBaseActionService,
              private _keycloakService: KeycloakService,
              private _auditService: AuditsReportsService) { }

  ngOnInit(): void {
    this.title.emit('Add internal audit');
    forkJoin([
      this._organisationService.getPorts(),
      this._vesselsService.getActiveVessels(),
    ])
      .subscribe(results => {
        this.locations = results[0];
        this.vessels = results[1];
      });
  }

  vesselsFormatter(vessel: Vessel) {
    if (vessel) {
      return vessel.name!.name;
    }
    return '';
  }

  documentFileAdded(doc: DocumentReference) {
    this.uploadedDocument = doc;
    this.auditReport.documentId = doc.id;
  }

  save() {
    this.auditReport.actions.push(this._actionService.userAction(ActionType.Update));
    this.auditReport.surveyorId = this._keycloakService.getUser().username;
    this.auditReport.surveyorName = this._keycloakService.getUser().fullName;
    this._auditService.add(this.auditReport).subscribe({ next: () => {
      this._pgMessagesService.publishMessage({
        level: MessageLevel.Info,
        topic: 'Vessel',
        message: 'An audit report is added.'
      });
      // this._router.navigate(['vessel', this.vessel.imo]).then(_ => {});
    }, error: () => {
      this._pgMessagesService.publishMessage({
        level: MessageLevel.Info,
        topic: 'Vessel',
        message: 'Error occurred while adding an audit report.'
      });
    }
    });
  }
}
